import React from 'react';
import { useState, useEffect } from "react";
import Select from 'react-select'
import { useLocation } from 'react-router-dom';


  const TrackerFilter = ({ trackerSettings, selectedFilters, setSelectedFilters, onFilterChange, filters = {}, disabledYear = false }) => {

    const lang = localStorage.getItem('language');
    const location = useLocation();
    const isTrackerPage = location.pathname.endsWith('/tracker');


    const filterCategories = [
      ...(isTrackerPage
        ? [{ key: 'source', label: trackerSettings?.source_title }]
        : []),
      { key: "donors", label: trackerSettings?.donor_title },
      { key: "aid_type", label : trackerSettings?.aid_type_title },
      { key: "sub_aid_type", label: trackerSettings?.sub_aid_title },
      { key: "recipient", label:  trackerSettings?.recipient_title },
      { key: "beneficiary", label : trackerSettings?.beneficiary_title },
      { key: "governate", label: trackerSettings?.governate_title  },
      { key: "year", label: trackerSettings?.delivery_dates_title  },
  ];
    
    const handleChange = (key, selectedOptions) => {
      const updatedFilters = {
          ...selectedFilters,
          [key]: selectedOptions ? selectedOptions.map(option => option.value) : [],
      };
  
      setSelectedFilters(updatedFilters);
      onFilterChange(updatedFilters);
    };
    
      const removeFilter = (title) => {
        
        let keyToUpdate = null;
        let idToRemove = null;
    
        Object.entries(selectedFilters).forEach(([key, ids]) => {
          const matchingOption = (filters[key] || []).find((item) => item.title === title);
          if (matchingOption) {
            keyToUpdate = key;
            idToRemove = matchingOption.id;
          }
        });
    
        if (!keyToUpdate || idToRemove === null) return;
    
        const updatedFilters = {
          ...selectedFilters,
          [keyToUpdate]: selectedFilters[keyToUpdate].filter((id) => id !== idToRemove),
        };
    
        setSelectedFilters(updatedFilters);
        onFilterChange(updatedFilters);
      };
  
      const displayedFilters = Object.entries(selectedFilters)
      .flatMap(([key, values]) => 
        values.map((id) => {
          const option = (filters[key] || []).find(item => item.id === id);
          return option ? option.title : null;
        })
      )
      .filter(Boolean); 

      const [inputValues, setInputValues] = useState({})

        return (
          <div className="row g-3 mb-3">
            {filterCategories.map(({ key, label }) => (
              <div className="col-lg-2 col-6 position-relative tracker-filter" key={key}>
                <Select
                classNamePrefix= {'select-filter'}
                isDisabled={disabledYear && key == 'year'}
                  options={(filters[key] || []).map(({ title , id}) => ({ value: id, label: title }))}
                  isMulti
                  placeholder=''
                  noOptionsMessage={() => lang === 'en' ? 'No options' : 'لا توجد خيارات'}
                  inputValue={inputValues[key] || ""}
                  onInputChange={(value) =>
                    setInputValues((prev) => ({ ...prev, [key]: value }))
                  }
                  onChange={(selectedOptions) => handleChange(key, selectedOptions)}
                  value={(selectedFilters[key] || []).map((value) => ({ value, label: value }))}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 3,
                  })}
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      borderColor: "#213469",
                      boxShadow: "none",
                      "&:hover": { borderColor: "none" },
                      minHeight: "49px",
                      cursor: "pointer",

                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: "#213469", 
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      color: "#213469", 
                      "&:hover": { color: "#213469" },
                    }),
                    indicatorSeparator: () => ({ display: "none" }),
                    menu: (provided) => ({
                      ...provided,
                      border: "1px solid #213469",
                      boxShadow : "none"
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: "transparent",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "transparent", 
                      },
                    }),
                  }}
                />
                {inputValues[key] ? "" : (
                  <p className="f-500 mb-0 select-p-placeholder">
                    {label}
                  </p>
                )}
              </div>
            ))}
              <div className="row g-3">
              {displayedFilters.length > 0 &&
                displayedFilters.map((title, index) => (
                  <div className="col-auto mb-3" key={index}>
                    <div className="sectoral-filter chosen d-flex justify-content-between align-items-center mt-0">
                      <div className="sectoral-filter-title">
                        <p style={{ paddingRight: lang === "en" ? "10px" : undefined, paddingLeft: lang !== "en" ? "10px" : undefined }}>
                          {title}
                        </p>
                      </div>
                      <img
                        src="/assets/images/close.svg"
                        alt="remove filter"
                        className="remove-filter"
                        onClick={() => removeFilter(title)} 
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                ))
              }
              </div>
          </div>
        );
      };

export default TrackerFilter
